<div class="panel-toggle" cdkOverlayOrigin #panelOrigin="cdkOverlayOrigin">
  <button class="toggle" (click)="panelOpen.set(!panelOpen())">
    <span class="label">My Locations</span>
    <span class="count">
      {{ selectionDisplayString() }}
    </span>
    <vulcan-icon class="chevron" size="12px" icon="caret-up" [class.open]="panelOpen()"></vulcan-icon>
  </button>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="panelOrigin" [cdkConnectedOverlayOpen]="panelOpen()"
  (overlayOutsideClick)="panelOpen.set(false)">


  <section class="dropdown">
    <div class="search-row">
      <mat-form-field appearance="outline">
        <mat-label>Search states</mat-label>
        <input matInput type="search" [(ngModel)]="searchTerm" />
        <mat-hint align="end">
          <a class="request-states" (click)="requestAdditionalStates()" tabindex="0"
            (keyup.enter)="requestAdditionalStates()">Request Additional
            States</a>
        </mat-hint>
      </mat-form-field>
    </div>
    @if (searchTerm() && searchTerm().length > 0) {
    @if (searchStates().length === 0) {
    <div class="no-results">No states found matching "{{ searchTerm() }}"</div>
    } @else {
    <div class="state-list">
      @for (state of searchStates(); track state) {
      <mat-checkbox [checked]="state.isSelected()" (change)="state.isSelected.set($event.checked)">
        {{ state.name }}
      </mat-checkbox>
      }
    </div>
    }
    } @else {
    <div>
      @for (region of regions(); track region.id) {
      <div class="region-row">
        <div class="expand" (click)="region.isExpanded.set(!region.isExpanded())" tabindex="0" (keyup.enter)="region.isExpanded.set(!region.isExpanded())">
          <vulcan-icon class="chevron" size="20px" icon="caret-up" [class.open]="region.isExpanded()"></vulcan-icon>
        </div>
        <mat-checkbox [checked]="region.isSelected()" [indeterminate]="region.isPartial()"
          (change)="toggleRegion(region, $event.checked)">
          {{ region.name }}
        </mat-checkbox>
      </div>

      @if (region.isExpanded()) {
      <div class="state-list">
        @for (state of region.children; track state.id) {
        <mat-checkbox class="state-checkbox" [checked]="state.isSelected()"
          (change)="state.isSelected.set($event.checked)">
          {{ state.name }}
        </mat-checkbox>
        }
      </div>
      }
      }
    </div>
    }

    <div class="active-header">
      <span>Active Selections</span>
      <button class="clear" [disabled]="selected().length === 0" type="button" (click)="clear()">Clear All</button>
    </div>

    <div class="chips">
      @for (state of selected(); track state) {
      <button class="chip" (click)="state.isSelected.set(false)">
        <span>{{ state.name }}</span>
        <span class="close">×</span>
      </button>
      }
    </div>
    <mat-divider></mat-divider>

  </section>
</ng-template>
